import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';


import AdjustPrompt from 'components/admin/AdjustPrompt';
import AuthButtonWithDropdown from 'components/base/AuthButtonWithDropdown';
import ExportRangeModal from 'components/base/ExportRangeModal';
import { ADJUST_TYPES, COUPON_TYPES } from 'config/CustomEnums';


import { ActionsDropdownForItem } from '../../../components/base/ActionsDropdown';
import AuthButton from '../../../components/base/AuthButton';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import ListButtonsGroup from '../../../components/base/ListButtonsGroup';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { ImportResource } from '../../../models/DownloadImportModel';
import { createAction, getHashKeyString } from '../../../utils';
import BaseListContainer from '../../base/BaseListContainer';
import BaseTabListContainer, { CustomerDefaultCautionDetail } from '../../base/BaseTabListContainer';
import Filter from './Filter';

import './CouponTransaction.scss';
import { NavBarNames } from 'config/NavBarNameList';

const TAB_RECORDS = 'Records';
const TAB_REPORTS = 'Reports';

function CouponTransaction({
  couponListDisplayFields,
  ticketListDisplayFields,
  dataList,
  pageInfo,
  totalCount,
  totalPage,
  currentPage,
  reportListDisplayFields,
  reportDataList,
  ticketReportDataList,
  checkedList,
  isTicket = false,
}) {
  const tableFields = isTicket ? ticketListDisplayFields : couponListDisplayFields;
  const exportResource = {
    couponRecords: `${isTicket ? 'Ticket' : 'Coupon'} Records`,
    reports: 'Reports',
  };
  const queryString = require('query-string');
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isExportAll, setIsExportAll] = useState(true);
  const [exportPromptSetting, setExportPromptSetting] = useState({
    show: false,
    exportResource: '',
  });
  const [adjustPrompt, setAdjustPrompt] = useState({
    show: false,
    adjustType: null,
    prefillData: {},
  });

  const activeTab = getHashKeyString(location.hash) || TAB_RECORDS;

  useEffect(() => {
    const searchDict = queryString.parse(location.search);
    const searchKey = searchDict['search'];
    const stringRank = searchDict['rank'] || 'true';
    const stringPage = searchDict['page'] || 1;
    const reportType = searchDict['report_type'];
    const timeRange = searchDict['time_range'];
    const rank = stringRank === 'true';
    const page = parseInt(stringPage);
    if (activeTab === TAB_RECORDS) {
      dispatch(
        createAction('couponTransactions/getCurrentPageCouponTransactions')({
          ...searchDict,
          coupon_type: isTicket ? COUPON_TYPES.TICKET : COUPON_TYPES.NORMAL,
          searchKey,
          rank,
          page,
        }),
      );
      dispatch(
        createAction('campaignList/getCampaignList')({
          campaignIds: searchDict['campaigns'],
          isSimpleList: true,
          isSelectorLoad: true,
          isAvailable: false,
          noLoading: true,
          searchNameOrId: true,
        }),
      );
      dispatch(
        createAction('earningRuleList/getSimpleEarningRuleListForSelector')({
          earningRuleIds: searchDict['earning_rules'],
          isSelectorLoad: true,
        }),
      );
      dispatch(
        createAction('couponList/getSimpleCouponSetListForSelector')({
          couponTemplateIds: searchDict[isTicket ? 'ticket_sets' : 'coupon_sets'],
        }),
      );
      if (searchDict?.transaction) {
        dispatch(
          createAction('transactions/getSimpleTransactionsForSelector')({
            transactionIds: searchDict['transaction'],
          }),
        );
      }
    }
    if (activeTab === TAB_REPORTS) {
      dispatch(
        createAction(
          `couponTransactions/${isTicket ? 'getCurrentPageTicketTransactionsReports' : 'getCurrentPageCouponTransactionsReports'}`,
        )({
          ...searchDict,
          reportType,
          timeRange,
          searchKey,
          rank,
          page,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location, queryString]);

  const exportCouponRecordsAction = () => {
    if (activeTab !== TAB_RECORDS || isExportAll) {
      dispatch(
        createAction('downloadAndImport/createDownloadTask')({
          from: ImportResource.couponRecord,
        }),
      );
      return;
    }
    const parsedSearch = queryString.parse(location.search);
    let expiredDateDict = {};
    if (parsedSearch?.expired_date) {
      switch (parsedSearch.expired_date) {
        case 'absolute':
          if (parsedSearch?.absolute) {
            const expiredDateRange = parsedSearch?.absolute?.split(',');
            expiredDateDict = {
              absoluteGte: expiredDateRange?.[0],
              absoluteLte: expiredDateRange?.[1],
            };
          }
          break;
        case 'relativeDay':
          if (parsedSearch?.relativeDay) {
            expiredDateDict = {
              relativeDay: parsedSearch.relativeDay,
            };
          }
          break;
        default:
          expiredDateDict = { allTime: true };
          break;
      }
    }
    const couponTransactionListIn = (checkedList || []).map((item) => item.pk);

    dispatch(
      createAction('downloadAndImport/createDownloadTask')({
        from: ImportResource.couponRecord,
        related: {
          ...expiredDateDict,
          typeIn: parsedSearch?.record_type?.split(','),
          creationDateGte: parsedSearch?.creation_date?.split(',')?.[0],
          creationDateLte: parsedSearch?.creation_date?.split(',')?.[1],
          purchaseDateGte: parsedSearch?.purchase_date?.split(',')?.[0],
          purchaseDateLte: parsedSearch?.purchase_date?.split(',')?.[1],
          separateFiles: false,
          customerNameIcontains: parsedSearch?.search,
          couponTransactionListIn: couponTransactionListIn,
          couponType: isTicket ? COUPON_TYPES.TICKET : COUPON_TYPES.NORMAL,
          mediumTypeIn: parsedSearch?.coupon_medium?.split(','),
          isEmptyReward:
            parsedSearch?.record_scope === 'REWARDED_RECORDS'
              ? false
              : parsedSearch?.record_scope === 'NON_REWARDED_RECORDS'
              ? true
              : null,
          targetCampaignIds: parsedSearch?.campaigns?.split(','),
          targetEarningRuleIds: parsedSearch?.earning_rules?.split(','),
          targetCouponTemplateIds: isTicket ? parsedSearch?.ticket_sets?.split(',') : parsedSearch?.coupon_sets?.split(','),
          transactionListIn: parsedSearch?.transaction?.split(','),
        },
      }),
    );
  };

  const exportReportAction = () => {
    if (activeTab !== TAB_REPORTS || isExportAll) {
      dispatch(
        createAction('downloadAndImport/createDownloadTask')({
          from: isTicket ? ImportResource.ticketReport : ImportResource.couponReport,
        }),
      );
      return;
    }
    const searchDict = queryString.parse(location.search);
    const reportType = searchDict['report_type'];
    const timeRange = searchDict['time_range']?.split(',');
    const nameIcontains = searchDict['search'];
    const couponReportListIn = (checkedList || []).map((item) => item.pk);

    dispatch(
      createAction('downloadAndImport/createDownloadTask')({
        from: isTicket ? ImportResource.ticketReport : ImportResource.couponReport,
        related: {
          nameIcontains,
          reportType,
          timeRangeGte: timeRange?.[0],
          timeRangeLte: timeRange?.[1],
          reportIdIn: couponReportListIn,
        },
      }),
    );
  };

  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={600}
      hideAllButtonWidth={530}
      extraButtons={[
        <AuthButton
          customClass="btn-back-button-common btn-download"
          title={`Adjust ${isTicket ? 'ticket' : 'coupon'}`}
          action={() => {
            setAdjustPrompt({
              show: true,
              adjustType: isTicket ? ADJUST_TYPES.ticket : ADJUST_TYPES.coupon,
            });
          }}
          requires={PermissionCodes.adjustAllRewards}
        />,
        <AuthButtonWithDropdown
          className="btn-download"
          permissionRequires={PermissionCodes.addExportjob}
          title={'Export'}
          options={[
            {
              title: exportResource.couponRecords,
              action: () => {
                setExportPromptSetting({
                  show: true,
                  exportResource: exportResource.couponRecords,
                });
              },
            },
            {
              title: exportResource.reports,
              action: () => {
                setExportPromptSetting({
                  show: true,
                  exportResource: exportResource.reports,
                });
              },
            },
          ]}
        />,
      ]}
      extraPopContent={[
        {
          requires: PermissionCodes.adjustAllRewards,
          action: () => {
            setAdjustPrompt({
              show: true,
              adjustType: isTicket ? ADJUST_TYPES.ticket : ADJUST_TYPES.coupon,
            });
          },
          content: `Adjust ${isTicket ? 'ticket' : 'coupon'}`,
        },
        {
          requires: PermissionCodes.addExportjob,
          action: () => {
            setExportPromptSetting({
              show: true,
              exportResource: exportResource.couponRecords,
            });
          },
          content: `Export ${exportResource.couponRecords}`,
        },
        {
          requires: PermissionCodes.addExportjob,
          action: () => {
            setExportPromptSetting({
              show: true,
              exportResource: exportResource.reports,
            });
          },
          content: `Export ${exportResource.reports}`,
        },
      ]}
    />,
  ];

  const couponRecordTypeTabs = [
    { key: 'all', name: 'All Types' },
    { key: 'EARN', name: 'Customer earned' },
    { key: 'BUY', name: 'Customer Acquired' },
    { key: 'GRANT', name: 'Admin added' },
    { key: 'RECLAIM', name: 'Admin removed' },
    { key: 'MERCHANT_GRANT', name: 'Merchant added' },
    { key: 'MERCHANT_RECLAIM', name: 'Merchant removed' },
  ];

  const reportTypeTabs = [
    { key: 'all', name: 'All Types' },
    { key: 'WEEKLY', name: 'Weekly' },
    { key: 'MONTHLY', name: 'Monthly' },
  ];

  const tableTabs = [
    {
      name: TAB_RECORDS,
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={couponRecordTypeTabs}
          pageInfo={pageInfo}
          totalCount={totalCount}
          groupActions={[]}
          searchPlaceholder="Search"
          useCaution
          cautionDetail={CustomerDefaultCautionDetail}
          filter={{ hasFilter: true, component: Filter, extraProperties: { isTicket } }}
          listContent={
            <BaseListContainer
              fields={tableFields}
              model={'couponTransactions'}
              dataList={dataList}
              totalPage={totalPage}
              deleteInfo={{
                data: [],
                title: '',
                relatedName: '',
                onComfirm: {},
              }}
              useCustomCommonActions={true}
              customCommonActions={(item) => {
                const actions = [
                  {
                    name: 'View details',
                    action: () => {
                      return history.push(`${location.pathname}/${item.pk}/`);
                    },
                  },
                ];
                return (
                  <ActionsDropdownForItem object={item} actions={actions} />
                );
              }}
              customClassName="coupon-record-table"
              permissionGroup={PermissionCodes.coupontransaction}
            />
          }
        />
      ),
    },
    {
      name: TAB_REPORTS,
      content: (
        <BaseTabListContainer
          tabs={reportTypeTabs}
          tabSearchKey={'report_type'}
          pageInfo={pageInfo}
          totalCount={totalCount}
          searchPlaceholder={'Search by report name'}
          groupActions={[]}
          filter={{ hasFilter: true, component: Filter }}
          listContent={
            <BaseListContainer
              fields={reportListDisplayFields}
              model={'couponTransactions'}
              dataList={isTicket ? ticketReportDataList : reportDataList}
              totalPage={totalPage}
              deleteInfo={{
                data: [],
                title: '',
                relatedName: '',
                onComfirm: {},
              }}
              useCustomCommonActions={true}
              customCommonActions={(item) => {
                const actions = [
                  {
                    name: 'Download',
                    requires: PermissionCodes.addExportjob,
                    href: item?.reportFileUrl,
                    action: () => {
                      dispatch({
                        type: 'admin/createAuditLog',
                        payload: {
                          data: {
                            dataType: isTicket ? 'ticketreport' : 'couponreport',
                            id: item.pk,
                          },
                        },
                      });
                    },
                  },
                ];
                return (
                  <ActionsDropdownForItem object={item} actions={actions} />
                );
              }}
            />
          }
        />
      ),
    },
  ];

  return (
    <>
      <CustomListComponent
        caution={{
          detail:
            `All ${isTicket ? 'ticket' : 'coupon'} records are listed here, you can view the ${isTicket ? 'ticket' : 'coupon'} transactions of each customer.`,
          title: isTicket ? NavBarNames.ticketRecords : NavBarNames.couponRecords,
        }}
        defaultActiveKey={activeTab}
        buttons={buttons}
        breadcrumb={<CustomBreadcrumb />}
        tabs={tableTabs}
        onTabChange={(key) => {
          history.push({ pathname: location.pathname, hash: key });
        }}
      />
      <ExportRangeModal
        show={exportPromptSetting?.show}
        title={`Export ${exportPromptSetting?.exportResource || ''}`}
        closeAction={() => {
          setExportPromptSetting({
            show: false,
            exportResource: '',
          });
        }}
        rightButton={{
          text: 'Export',
          action: () => {
            if (
              exportPromptSetting?.exportResource === exportResource.reports
            ) {
              exportReportAction();
            } else if (
              exportPromptSetting?.exportResource ===
              exportResource.couponRecords
            ) {
              exportCouponRecordsAction();
            }
            setExportPromptSetting({
              show: false,
              exportResource: '',
            });
          },
          requires: PermissionCodes.addExportjob,
        }}
        isExportAll={isExportAll}
        setIsExportAll={setIsExportAll}
      />
      <AdjustPrompt
        show={adjustPrompt.show}
        adjustType={adjustPrompt.adjustType}
        prefillData={{
          ...(adjustPrompt.prefillData || {}),
        }}
        setShow={(value) => setAdjustPrompt({ show: value })}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  couponListDisplayFields: state.couponTransactions.listDisplayFields,
  ticketListDisplayFields: state.couponTransactions.ticketListDisplayFields,
  dataList: state.couponTransactions.currentPageCouponTransactionList,
  reportDataList:
    state.couponTransactions.currentPageCouponTransactionReportList,
  ticketReportDataList: state.couponTransactions.currentPageticketTransactionReportList,
  pageInfo: state.couponTransactions.pageInfo,
  totalCount: state.couponTransactions.totalCount,
  totalPage: state.couponTransactions.totalPage,
  currentPage: state.couponTransactions.currentPage,
  reportListDisplayFields: state.couponTransactions.reportListDisplayFields,
  checkedList: state.couponTransactions.checkedList,
});

export default connect(mapPropsToState)(CouponTransaction);